import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerService } from '../customer/shared/services/customer.service';
import { CustomDateParserFormatter } from '../shared/adapters/datepicker-adapter';
import { orderSearchModel } from './shared/models/orderSearchModel';
import { OrderService } from './shared/services/order.service';
import { CustomerProfileComponent } from '../customer/customer-profile/customer-profile.component';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.css'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class OrderComponent implements OnInit {
  orderSearchCriteria: orderSearchModel;
  orders: any;
  page: number;
  DateFrom: NgbDateStruct;
  DateTo: NgbDateStruct;
  OrderCancelReason: any[] = [];
  closeResult;
  custProfile: any;
  maxDate: NgbDateStruct;
  tableData: any;
  cardList : any[] = [];
  cardId : any;
  orderId : any;
  constructor(private _toaster: ToastrService, private _modalSvc: NgbModal, public _orderSvc: OrderService, private _customerSvc: CustomerService,) { }

  ngOnInit() {
    const current = new Date();
    this.maxDate = { year: current.getFullYear(), month: current.getMonth() + 1, day: current.getDate() };
    this.resetForm();
    this.getOrders(1);
  }
  
  resetForm() {
    let from = new Date();
    let to = new Date();
    from.setDate(from.getDate() - 7);
    this.DateFrom = { year: from.getFullYear(), month: from.getMonth() + 1, day: from.getDate() }
    this.DateTo = { year: to.getFullYear(), month: to.getMonth() + 1, day: to.getDate() },
      this.orderSearchCriteria = {
        DateFrom: (from.getMonth() + 1) + '/' + from.getDate() + '/' + from.getFullYear(),
        DateTo: (to.getMonth() + 1) + '/' + to.getDate() + '/' + to.getFullYear(),
        PageNo: 1,
        PageSize: 10,
        CustomerName: '',
        OrderStatusId: 1000,
        DriverId: 3,
        FranchiseId: 201,
        IsCancel: false,
        OrderNo: "",
        CancelReasonId: 0,
        City: "",
        PickedByDriverId: "",
        ZipCode: "",
      };
    this.page = this.orderSearchCriteria.PageNo;
  }

  cancelSearch() {
   
    this.DateFrom = this.DateTo = null;
    this.tableData = null;
    this.orders.PaginatedResult.TotalRecords = 0;
  }

  getOrders(PageNo: number) {
    this.orderSearchCriteria.PageNo = PageNo;
    this.orderSearchCriteria.DateFrom = this.DateFrom.month + '/' + this.DateFrom.day + '/' + this.DateFrom.year;
    this.orderSearchCriteria.DateTo = this.DateTo.month + '/' + this.DateTo.day + '/' + this.DateTo.year;
    this._orderSvc.getOrderStatuses(this.orderSearchCriteria).subscribe(response => {
      this.orders = response;
      this.tableData = this.orders;
      this.orderSearchCriteria = response?.SearchCriteria;

    });
  }

  dismiss() {
    this.orderSearchCriteria.CancelReasonId = 0;
    this._modalSvc.dismissAll();
  }

  private getDismissReason(reason: any): string {
    this.orderSearchCriteria.CancelReasonId = 0;
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getOrderCancelReason(orderCancel, mod) {
    //var mod;
    console.log(mod);

    if (mod.OrderStatusId == 10) {
      this._orderSvc.getOrderCancelReasons().subscribe(orderCancelReasons => {
        this.OrderCancelReason = orderCancelReasons.OrderCancelReason;
        this._modalSvc.open(orderCancel, { ariaLabelledBy: 'modal-basic-title', scrollable: true, size: 'sm' }).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
          if (this.orderSearchCriteria.CancelReasonId > 0) {
            this._orderSvc.changeOrderStatusByAdmin(mod.OrderNoStr, "Admin", "Cancel", this.orderSearchCriteria.CancelReasonId).subscribe(response => {
              this.orders.Orders.forEach(order => {
                if (order.OrderNoStr === mod.OrderNoStr) {
                  order.OrderStatusId = 80;
                  order.OrderStatus = "Cancelled";
                  order.CancelledBy = "Admin";
                }
              });
            });
          }
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
      })
    }
    else if (mod.OrderStatusId == 80) {
      if (confirm("Are you sure to Reopen this order ?")) {
        this._orderSvc.changeOrderStatusByAdmin(mod.OrderNoStr, "Admin", "ReActive", 0).subscribe(response => {
          console.log(response);
          this.orders.Orders.forEach(order => {
            if (order.OrderNoStr === mod.OrderNoStr) {
              order.OrderStatusId = 10;
              order.OrderStatus = "Order placed successfully";
              order.CancelledBy = "";
            }
          });
        })
      }
    }
  }

  getCustomerProfile(customerId) {
    if (customerId) {
      this._customerSvc.getCustomerProfile(customerId).subscribe(CustomerProfile => {
        if (CustomerProfile) {
          this.custProfile = CustomerProfile;
          if (CustomerProfile.Customer.ImagePath) {
            this.custProfile.Customer.ImagePath = environment.config.rootUrl + CustomerProfile.Customer.ImagePath + "?" + new Date().getTime();
          }
          else {
            this.custProfile.Customer.ImagePath = "http://dcdbackoffice.ssasoft.com/images/editprofile.jpg";
          }         
          const modalRef = this._modalSvc.open(CustomerProfileComponent);
          modalRef.componentInstance.custProfile = this.custProfile;
        }
      });

    }
  }

  getCustomerCard(getCard, mod: any){
    
    this._customerSvc.getCustomerCard(mod?.CustomerId).subscribe((card : any) => {
      if(card){

        this.cardList = card?.Cards;
        this.cardList.forEach(card => {
          if(card?.IsDefault){
            this.cardId = card?.ID;
            this.orderId = mod?.ID
          }
        });
        this._modalSvc.open(getCard, { ariaLabelledBy: 'modal-basic-title', scrollable: true, size: 'sm' }).result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
      }
    });
  }

  setDefaultCard(){
    this._modalSvc.dismissAll();
    let reqBody = {
      "cardId": this.cardId,
      "orderId": this.orderId
    }
    this._customerSvc.setDefaultCard(reqBody).subscribe(card => {
      if(card?.ResultMessages.length > 0){
        card?.ResultMessages.forEach(element => {
          if(element?.MessageType === 'success'){
            this._toaster.success(element?.Message);
          }
          else{
            this._toaster.error(element?.Message);
          }
        });
       
      }
    });
  }

}
